import React from 'react';
import BDA from '../assets/BookDoctorAppointment.jpg';
import CoW from '../assets/ChatonWhatsApp.jpg';
import MO from '../assets/MedicalOpinion.jpg';

const FixedImages = () => {
  return (
    <div className="fixed top-1/2 right-4 transform -translate-y-1/2 z-50 space-y-1">
      <img
        href="#"
        src={BDA}
        alt="Book Doctor Appointment"
        className="transform transition-all duration-300 hover:scale-105 w-20 h-20 object-contain cursor-pointer"
      />
      <img
        src={CoW}
        alt="Chat on Whatsapp"
        className="transform transition-all duration-300 hover:scale-105 w-20 h-20 object-contain cursor-pointer"
      />
      <img
        src={MO}
        alt="Medical Opinion"
        className="transform transition-all duration-300 hover:scale-105 w-20 h-20 object-contain cursor-pointer"
      />
    </div>
  );
};

export default FixedImages;
